import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_SkillItem = _resolveComponent("SkillItem")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AddOrEditSkill = _resolveComponent("AddOrEditSkill")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { loading: _ctx.loading }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Add Technical Skills ")
        ])),
        _: 1
      }),
      _createVNode(_component_v_form, {
        ref: "frmMain",
        "lazy-validation": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoBox, { title: "Add your technical Skills, then select your favourite skills from the list. If you don’t see your skill listed, you can submit it manually" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "primary_btn w-100",
                        "prepend-icon": "mdi-plus",
                        onClick: _ctx.showAddSkill
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Add Skill")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.teammemberSkillList && _ctx.teammemberSkillList.length)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("h4", null, "Select your Favourite Skills (Choose up to 5)", -1)
                        ])),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teammemberSkillList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          cols: "12",
                          key: 'row_' + index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SkillItem, {
                              skill: item,
                              onEdit: ($event: any) => (_ctx.edit(item)),
                              onRemove: ($event: any) => (_ctx.remove(item)),
                              onChangeSkillStatus: ($event: any) => (_ctx.changeSkillStatus(item)),
                              teammemberSkillList: _ctx.teammemberSkillList,
                              skillList: _ctx.skillList
                            }, null, 8, ["skill", "onEdit", "onRemove", "onChangeSkillStatus", "teammemberSkillList", "skillList"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showJobRequestConfirm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showJobRequestConfirm) = $event)),
        "max-width": "500",
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showJobRequestConfirm = false), ["esc"])),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_confirm_dialog, {
            loading: _ctx.sendReqeustLoadingProgress,
            message: _ctx.confirmModel,
            showInput: "",
            inputLable: "Job Title",
            onConfirm: _ctx.confirmSendJobRequest,
            onCancel: _ctx.cancelSending
          }, null, 8, ["loading", "message", "onConfirm", "onCancel"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.showAddOrEdit)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 0,
            modelValue: _ctx.showAddOrEdit,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddOrEdit) = $event)),
            "max-width": "1000",
            onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.closeEdit()), ["esc"])),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AddOrEditSkill, {
                isHiringmanager: _ctx.isHiringmanager,
                onSkillCertificateChanged: _ctx.skillCertificateChanged,
                onSaveSkill: _ctx.saveSkill,
                onAddSkill: _ctx.addSkill,
                uploadedCertificateUrl: _ctx.uploadedCertificateUrl,
                skillModel: _ctx.editingSkillModel,
                tmId: _ctx.tmModel.Id,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeEdit())),
                skillList: _ctx.skillList,
                loading: _ctx.loading
              }, null, 8, ["isHiringmanager", "onSkillCertificateChanged", "onSaveSkill", "onAddSkill", "uploadedCertificateUrl", "skillModel", "tmId", "skillList", "loading"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}